import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addToCart } from '../../store/cartSlice';
import { addToWishlist, removeFromWishlist } from '../../store/wishlistSlice';
import { showShopToast } from '../../utils/shopToast';
import { Card, Button, Row, Col, Container } from 'react-bootstrap';
import ProductImageGallery from './ProductImageGallery';
import './ProductosDestacados.css';

// ✅ Variable de entorno
const API_URL = import.meta.env.VITE_API_URL;

function formatCOP(value) {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
}

function ProductosDestacados() {
  const [productos, setProductos] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const wishlistItems = useSelector(state => state.wishlist.items || []);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');   

  useEffect(() => {
    fetch(`${API_URL}/destacados`)
      .then((res) => res.json())
      .then((data) => setProductos(data))
      .catch((err) => console.error('Error al obtener productos destacados:', err));
  }, []);

  const isInWishlist = (id) => {
    return wishlistItems.some(item => item.id === id);
  };

  const handleAddToCart = (e, product) => {
    e.stopPropagation();
    dispatch(addToCart(product));
    showShopToast(`${product.name} agregado al carrito`, 'success');
  };

  const handleToggleWishlist = (e, product) => {
    e.stopPropagation();
    if (isInWishlist(product.id)) {
      dispatch(removeFromWishlist(product.id));
      setToastMessage(`${product.name} eliminado de la lista de deseos`);
    } else {
      dispatch(addToWishlist(product));
      setToastMessage(`${product.name} agregado a la lista de deseos`);
    }
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleProductDetails = (productId) => {
    navigate(`/producto/${productId}`);
  };

  // Agrupa productos en grupos de 4
  const chunked = [];
  for (let i = 0; i < productos.length; i += 4) {
    chunked.push(productos.slice(i, i + 4));
  }

  return (
    <section className="py-2 featured-products">
      <Container>
        <h2 className="text-center mb-4">Productos Destacados</h2>
        {chunked.map((grupo, idx) => (
          <Row className="g-4 justify-content-center" key={idx}>
            {grupo.map((product) => {
              return (
                <Col md={3} sm={6} xs={12} key={product.id}>
                  <Card
                    className="h-100 shadow-sm text-center product-card position-relative"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleProductDetails(product.id)}
                  >
                    <div
                      className="position-absolute top-0 end-0 p-2"
                      onClick={(e) => handleToggleWishlist(e, product)}
                      title={isInWishlist(product.id) ? 'Eliminar de la lista de deseos' : 'Agregar a la lista de deseos'}
                      style={{ zIndex: 10 }}
                    >
                      <i
                        className={`bi bi-heart${isInWishlist(product.id) ? '-fill text-danger' : ''}`}
                        style={{ fontSize: '1.5rem', cursor: 'pointer' }}
                      ></i>
                    </div>
                    <div className="imageG" onClick={e => e.stopPropagation()}>
                      <ProductImageGallery
                        imageUrl={product.imageUrl}
                        productName={product.name}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        showThumbnails={false}
                        slideInterval={3000}
                        autoPlay={true}
                      />
                    </div>
                    <Card.Body className="product-card-body">
                      <Card.Title className="product-title">{product.name}</Card.Title>
                      <Card.Text className="product-description">{product.description}</Card.Text>
                      <Card.Text className="fw-bold text-success product-price">
                        Precio: {formatCOP(product.priceCOP)}
                      </Card.Text>
                      {/* <Card.Text className="text-muted small">
                        Precio en USD: ${product.price}
                      </Card.Text> */}
                      {/* {pdfs.pdf1 && (
                        <div className="mt-auto" onClick={e => e.stopPropagation()}>
                          <a
                            href={pdfs.pdf1}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary w-100 mb-2"
                          >
                            Descargar Especificaciones (PDF)
                          </a>
                        </div>
                      )} */}
                      <Button
                        variant="success"
                        className="w-100 mt-2 featured-add-to-cart-btn"
                        onClick={e => handleAddToCart(e, product)}
                      >
                        <i className="bi bi-cart-plus-fill me-2" aria-hidden="true"></i>
                        <span>Agregar al carrito</span>
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
          
        ))}
        {/* Toast de Bootstrap */}
        <div
          className="toast-container position-fixed bottom-0 end-0 p-3 shop-toast-container"
          style={{ zIndex: 9999 }}
        >
          <div
            className={`toast align-items-center text-bg-success border-0 ${showToast ? 'show' : 'hide'}`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="d-flex">
              <div className="toast-body">
                {toastMessage}
              </div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setShowToast(false)}
              ></button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default ProductosDestacados;
